<dv-grid [actions]="actions()">
  <ag-grid-angular
    vtGridWithSidesheet
    dvPinSelectedRow
    class="ag-theme-devinco"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
    (selectionChanged)="onSelectionChanged($event)">
  </ag-grid-angular>
</dv-grid>
